// extracted by mini-css-extract-plugin
export default {"container":"Distribution__container-cz4Gs","checkbox":"Distribution__checkbox-_BGKc","sublabel":"Distribution__sublabel-jsJQq","radio":"Distribution__radio-pCbdE"};